<template>
	<span class="has-bbox-bubble">
		<span
		>
			<slot />
		</span>
		<div
			class="bbox-bubble"
		>
			<div
				v-if="!!counter"
				class="
					bbox-bubble-default
					padding-right-tiny
					padding-top-xtiny
					padding-left-tiny
					padding-bottom-xtiny
					bg-ink-base
					white-base
					font-size-normal"
			>
				<template v-if="!!counter">{{ counter }}</template>
			</div>
		</div>
	</span>
</template>

<script>
export default {
	name: 'bbox-iconBubbleCounter',
	props: {
		counter: String | Number,
		text: String,
		banner: Boolean,
	},
};
</script>

<style scoped>
.has-bbox-bubble {
	position: relative;
	display: inline-block;
}
.bbox-bubble {
	position: absolute;
	z-index: 1;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-content: center;
	justify-items: center;
	align-items: center;
}
.bbox-bubble {
	top: 1.3rem;
	left: 53%;
	transform: translate(-50%, -100%);
}
.bbox-bubble-default {
	border-radius: 50%;
	height: 2.3rem;
	width: 2.2rem;
	padding: 0 0.8rem 0 0.8rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>

<docs>

#### IconBubbleCounter
Este componente é utilizado para exibir um ícone (ou imagem) com um contador na parte superior direita.

```js

const value = 3;
<b-icon-bubble-counter counter="value" class="display-inline-block">
	<bbox-icon class="green-darker-1">
		<icon-check-circle />
	</bbox-icon>
</b-icon-bubble-counter>

```

</docs>
